import React, { Component } from 'react';
import { connect } from 'react-redux';
import NRG from './NRG/index.jsx';
import PlaceOrder from './PlaceOrder';
import Charts from './charts'
import Header from './header'
import {isMobile} from 'react-device-detect';

class MainPage extends Component {
  renderPlacement(){
    return (
      <div className='row' style={{marginTop:'0px'}}>
       <div className='col m6 placeIt' style={{}}>
         <div className='col s12'>
           <h6 style={{marginTop:'10px',float:'left'}}>
             <span style={{cursor:'pointer',paddingRight:'10px',color:'white'}}>
               Place Order
             </span>
           </h6>
         </div>
         <div className='col s12 section' style={{height:'254px'}}>
           <PlaceOrder/>
         </div>
       </div>
       <div className='col m6 placeIt2' style={{}}>
         <div className='col s12'>
           <h6 style={{marginTop:'10px',float:'left'}}>
             <span style={{cursor:'pointer',paddingRight:'10px',color:'white'}}>
               Collateral Info
             </span>
           </h6>
         </div>
         <div className='col s12 section' style={{height:'254px'}}>
           <NRG />
         </div>
       </div>
     </div>
    )
  }
  render() {
    return (
      <div className="col m6" style={{paddingTop:'0px'}}>
         {!isMobile && <Charts/>}
         {this.renderPlacement()}
      </div>
		)
  }
}

export default MainPage
